export const clerkAllowedRedirectOrigins = [
  /^https:\/\/(?:[a-z0-9-]+\.)?iebridge\.com$/,
  /^https:\/\/(?:[a-z0-9-]+\.){0,2}iebridge\.app$/,
];
